jQuery(document).ready(function ($) {
    var scroll_position = $(window).scrollTop();
    var menu_position = 110;

    function fixed_menu(scroll_position, menu_position) {
        if (scroll_position > menu_position) {
            $('.site-header').addClass('fixed');
        } else {
            $('.site-header').removeClass('fixed');
        }
    }

    $(window).scroll(function () {
        var $this = $(this);
        var scroll_top = $this.scrollTop();

        fixed_menu(scroll_top, menu_position);
    });

    fixed_menu(scroll_position, menu_position);
});